import { createFileRoute, redirect } from '@tanstack/react-router'
import { resolveSession } from '../features/auth/session'
import { canSeeSatisfactionReport, SatisfactionReport, satisfactionReportQuery } from '../features/satisfaction'

export const Route = createFileRoute('/satisfaction')({
  beforeLoad: async ({ context }) => {
    const session = await resolveSession(context.queryClient)
    if (session.kind === 'signed_in' && !canSeeSatisfactionReport(session.me.role)) throw redirect({ to: '/' })
  },
  loader: ({ context }) => context.queryClient.ensureQueryData(satisfactionReportQuery()),
  component: SatisfactionReport,
})
